module.exports = __webpack_public_path__ + "0369797b6d433ba2a6f3831a201057a3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/frilly-flower-orange-s.png
// module id = 2812
// module chunks = 0